module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('table', {
    staticStyle: {
      "border-style": "hidden"
    }
  }, [_c('caption', [_c('b', [_vm._v("Table 1")]), _vm._v(" The 20 Lean and Green Organizations with Stories in This Book")]), _vm._v(" "), _c('thead', [_c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Organization and Website URL")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Sites Visited (products, services)")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("My Favorite Lean and Green Stories")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Agilent Technologies (formerly part of Hewlett-Packard) "), _c('a', {
    attrs: {
      "href": "http://www.agilent.com",
      "target": "_blank"
    }
  }, [_vm._v("www.agilent.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("South Queensferry, Scotland (telecommunications)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Security guards wrote “nasty” notes to employees to encourage them to turn off computer screens at night; the result: 400 megawatts hours of electricity saved per year.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Apple Computer Corporation "), _c('a', {
    attrs: {
      "href": "http://www.apple.com",
      "target": "_blank"
    }
  }, [_vm._v("www.apple.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Sacramento, California, USA (computer products)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Team Recycle drove Apple to recycle—which it now does for 97.3 percent of all incoming materials.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("British Aerospace, Military Aircraft & Aerostructures Division "), _c('a', {
    attrs: {
      "href": "http://www.bae.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.bae.co.uk")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Samlesbury, England (aircraft)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("The company adopted an at-home environmental program, including a quiz written by an employee about Lean and Green shopping.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Celestica Inc. "), _c('a', {
    attrs: {
      "href": "http://www.celestica.com",
      "target": "_blank"
    }
  }, [_vm._v("www.celestica.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Toronto, Canada (electronics manufacturing services)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Instead of replacing ozone-depleting cleaners with water cleaners, they made the whole cleaning process unnecessary.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Compaq Computer Corporation "), _c('a', {
    attrs: {
      "href": "http://www.compaq.com",
      "target": "_blank"
    }
  }, [_vm._v("www.compaq.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Houston, Texas, USA (personal computers)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Architects designed buildings with skylights, to significantly reduce electricity use.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Horizon Organic Dairy, Inc. "), _c('a', {
    attrs: {
      "href": "http://www.horizonorganic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.horizonorganic.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Paul, Idaho, and Annapolis Maryland, USA (dairy farm)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Through organic farming and by treating the cows better, the company eliminated the need to buy chemicals, hormones, or fertilizers."), _c('a', {
    staticClass: "right",
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("IBM Corporation "), _c('a', {
    attrs: {
      "href": "http://www.ibm.com",
      "target": "_blank"
    }
  }, [_vm._v("www.ibm.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Endicott, New York, USA (printed-circuit boards)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("By developing a method to reuse etchant chemicals through contact with oxygen-rich air, the company reduced its use of etchants by 50 million gallons a year.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Intel Corporation "), _c('a', {
    attrs: {
      "href": "http://www.intel.com",
      "target": "_blank"
    }
  }, [_vm._v("www.intel.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Chandler, Arizona, USA (semiconductors)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Designing green manufacturing processes for products to be released 8 to 12 years into the future reduces the need to buy abatement equipment or get permits for hazardous processes that otherwise would have been used in the interim.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ITT Cannon, a division of ITT Industries "), _c('a', {
    attrs: {
      "href": "http://www.ittcannon.com",
      "target": "_blank"
    }
  }, [_vm._v("www.ittcannon.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Santa Ana, California, USA (connectors for ships, airplanes, etc.)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Employees convinced the military to use degreasers that do not deplete the ozone and that cost less.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ITT Gilfillan, a division of ITT Industries "), _c('a', {
    attrs: {
      "href": "http://www.gilfillan.itt.com",
      "target": "_blank"
    }
  }, [_vm._v("www.gilfillan.itt.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Van Nuys, California, USA (radar)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("This company developed a method of labeling parts using a computer printer instead of smelly, hazardous paints."), _c('a', {
    staticClass: "right",
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Kyocera Corporation "), _c('a', {
    attrs: {
      "href": "http://www.kyocera.co.jp",
      "target": "_blank"
    }
  }, [_vm._v("www.kyocera.co.jp")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tokyo, Japan (printers)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Designers developed printers that cost less to use and have fewer parts to replace.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Louisiana-Pacific Corporation "), _c('a', {
    attrs: {
      "href": "http://www.lpcorp.com",
      "target": "_blank"
    }
  }, [_vm._v("www.lpcorp.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Hines, Oregon, USA (wood products for building supplies)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Management overhauled the corporate culture, teaching employees to communicate with management and teaching management to value decisions that are environmentally sound.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("LSI Logic Corporation "), _c('a', {
    attrs: {
      "href": "http://www.lsil.com",
      "target": "_blank"
    }
  }, [_vm._v("www.lsil.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Gresham, Oregon (custom semiconductors for communications products)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("By reusing water in the production facility, the manufacturing process needs 63 percent less water than it did before.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NEC Corporation "), _c('a', {
    attrs: {
      "href": "http://www.nec-global.com",
      "target": "_blank"
    }
  }, [_vm._v("www.nec-global.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tokyo, Japan (semiconductors and consumer electronics)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("The company’s “zero waste” program is saving 0.2 percent in product costs.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Philips Electronics N.V. "), _c('a', {
    attrs: {
      "href": "http://www.philips.com",
      "target": "_blank"
    }
  }, [_vm._v("www.philips.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Eindhoven and Nijmegen, Holland (semiconductors for televisions, shavers, and other products)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Employees who design environmentally sound products and manage plants with Lean and Green results are eligible to win the company’s EcoVision award."), _c('a', {
    staticClass: "right",
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Polaroid Corporation "), _c('a', {
    attrs: {
      "href": "http://www.polaroid.com",
      "target": "_blank"
    }
  }, [_vm._v("www.polaroid.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Dumbarton, Scotland (cameras)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("After redesigning the product assembly process to nearly eliminate wasted materials, the cost of manufacturing was reduced by 20 percent.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Santa Monica "), _c('a', {
    attrs: {
      "href": "http://www.santa-monica.ca.us",
      "target": "_blank"
    }
  }, [_vm._v("www.santa-monica.ca.us")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Santa Monica, California, USA (city government)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("This city was the first on the West Coast to pave residential streets with white-top, which is stronger and thinner than black asphalt, reduces urban heat by 15 degrees on the street level, lasts 50 years instead of 5, and costs just a little more to install.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Sony Corporation "), _c('a', {
    attrs: {
      "href": "http://www.sony.com",
      "target": "_blank"
    }
  }, [_vm._v("www.sony.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tokyo, Japan (sound systems and other products)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("The company recycles sludge to make cement and has implemented other waste-less and recycle-more ideas; waste disposed of per unit of sales fell 30 percent in four years.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Texas Instruments Incorporated "), _c('a', {
    attrs: {
      "href": "http://www.ti.com",
      "target": "_blank"
    }
  }, [_vm._v("www.ti.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Dallas, Texas, USA (semiconductors)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Having planned to design-out hazardous materials in 6 to 12 months, employees eliminated the use of 49 of 50 hazardous chemicals in only 2 months.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Thomson Multimedia "), _c('a', {
    attrs: {
      "href": "http://www.thomson-multimedia.com",
      "target": "_blank"
    }
  }, [_vm._v("www.thomson-multimedia.com")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Boulogne, France (televisions and other consumer products)")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Scientists improved the plastic for television cabinets to eliminate not only any caustic paints but also the entire expensive and time-consuming painting process.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1792acf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap1t1.vue
// module id = 81
// module chunks = 0